import { createSelector } from '@reduxjs/toolkit';
import type { EventOccurrenceViewModel } from '@trinnvis/dabih-api-client';
import { getOrganization } from '../organization/getOrganization';

export const eventOccurrencesNotDeleted = createSelector(
  getOrganization,
  (organization): EventOccurrenceViewModel[] => {
    if (organization === undefined) return [];
    return organization.eventOccurrences ?? [];
  },
);
